import React, { useState } from 'react';
import axios from 'axios';
import './FeedbackWidget.css';

function FeedbackWidget({ user }) {
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setSubmitting(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/feedback`, { message }, {
        withCredentials: true
      });
      setSubmitted(true);
      setMessage('');
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      console.error('Error submitting feedback:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="feedback-widget">
      <div className="feedback-widget-header">
        <div className="feedback-widget-title">
          <span className="feedback-beta-badge">BETA</span>
          <h3>Share Your Feedback</h3>
        </div>
        <p className="feedback-widget-subtitle">
          Spotted a bug? Have a wish? Testing something weird? Drop a note — we read every one.
        </p>
      </div>

      {submitted ? (
        <div className="feedback-success">
          <span className="feedback-success-icon">✓</span>
          <div>
            <strong>Thanks, {user.name.split(' ')[0]}!</strong>
            <p>Your note has been received.</p>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="feedback-form">
          <textarea
            className="feedback-textarea"
            placeholder="e.g. &quot;The report PDF is missing engagement data for one client&quot; or &quot;Would love to filter by date range from the dashboard&quot;"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={3}
          />
          <div className="feedback-form-footer">
            <span className="feedback-from">
              Submitting as <strong>{user.name}</strong>
            </span>
            <button
              type="submit"
              className="feedback-submit-btn"
              disabled={submitting || !message.trim()}
            >
              {submitting ? 'Sending...' : 'Send Feedback'}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default FeedbackWidget;
